document.addEventListener("DOMContentLoaded", () => {
  const formContainer = document.querySelector(".form-container");

  const observer = new MutationObserver((mutationsList, observer) => {
    const form = document.querySelector("form-embed");

    if (form) {
      observer.disconnect();
      const shadow = form.shadowRoot;

      const sheet = new CSSStyleSheet();
      sheet.insertRule(`
    input, button[aria-expanded], textarea {
      border-radius: var(--style-border-radius-inputs) !important;
      box-shadow: none !important;
      border: 1px solid #CCC !important;
      accent-color: #CCC !important;
       font: inherit  !important;
    }
     
  `);

      sheet.insertRule(`
   h2{
    font-family: var(--font-primary--family) !important;
    font-weight: 400 !important;
    font-size: 2rem  !important;
    line-height: 1.3;

    
     
  `);

sheet.insertRule(`._inline_1q1d2_47 ._formContainer_1q1d2_30{
  max-width: 410px !important;}`)

      sheet.insertRule(`
  ._gridItemContent_1q1d2_257{
  padding: 0 !important;}
  `);
      sheet.insertRule(`
        ._inline_1q1d2_47{
        justify-content: center !important;}
        `);
      sheet.insertRule(`
   form{
   font-family: var(--font-primary--family) !important;
     margin:auto;
    }
     
  `);

      sheet.insertRule(`
   p{
   font-family: var(--font-primary--family) !important;
     
    }
     
  `);

      sheet.insertRule(`
    button[type="submit"] {
         max-height: 40px;
    padding: 12px 25px;
    font: inherit;
    border-radius: var(--style-border-radius-inputs) !important;
    border: none;
    cursor: pointer;
    display: inline-flex
;
    align-items: center;
    justify-content: center;
    line-height: 1;
    }
    `);

      sheet.insertRule(`
        label {
           
           color: #000 !important;
          
            
         }
         `);

      // sheet.insertRule(`
      //     legend {

      //      display: none !important;

      //      }
      //      `);

      shadow.adoptedStyleSheets.push(sheet);
      formContainer.classList.add("loaded");
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
